import { render, staticRenderFns } from "./SvgFrontFaceDriversLicense.vue?vue&type=template&id=0a0f6247&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports